var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"stepsScreen",staticClass:"steps-screen"},[_c('nav',{staticClass:"steps-screen__nav"},[_vm._t("stepper")],2),_c('div',{ref:"steps",staticClass:"steps-screen__container"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }